import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Why not just build this myself?',
    a: "You can! But it's 2-3 weeks of work: LLM routing, usage tracking, cost calculation, billing webhooks, API key management, deployment, scaling, monitoring. TokenGates does it in 5 minutes with a web form."
  }, {
    q: 'Do I need to deploy anything?',
    a: "No. It's fully managed. Create project → add keys → get endpoint. We handle global deployment, scaling, uptime, monitoring. You write zero infrastructure code."
  }, {
    q: 'Do you see our data/prompts?',
    a: "On Free/Pro plans, requests flow through our global CDN. We don't log prompts. On Enterprise plan, we deploy in YOUR infrastructure - data never leaves your network."
  }, {
    q: 'How does authentication work?',
    a: "You have two options: 1) Pass your user's JWT token from providers like Clerk or PropelAuth directly to our API. 2) Use a Master API Key from your backend and pass a customer_id header for attribution."
  }, {
    q: 'How does metered billing work?',
    a: 'We auto-create billing meters in Stripe/Polar when you connect your key. Every API request → tokens counted → cost calculated with your margin → synced to meter in real-time.'
  }];
  return <section id="faq" className="py-24 bg-gray-50" data-id="element-13">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-16">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-18" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-19">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-20">
        <span className="font-bold text-gray-900" data-id="element-21">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-22" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-23" />}
      </button>
      {isOpen && <div className="px-6 py-4 border-t border-gray-100 text-gray-600 leading-relaxed" data-id="element-24">
          {answer}
        </div>}
    </div>;
}